import {
  Sample,
  SampleFilters,
  SampleFiltersTranslator,
  SampleSortingOptionsConsts,
  samplesConstants,
} from "../../../api/Samples";

import { EntitySidebarTile, EntitySidebarTileProps } from "./EntitySidebarTile/EntitySidebarTile";
import { NotAvailable, NotSet } from "../../misc/UIconstants";
import { DateTimeRenderer } from "../../datetime/DateTimeFormatter";
import { Dispatch, SetStateAction, useCallback } from "react";
import { RenderTabStoreHistoryButton } from "../../tables/Tabs/history/TabStoreHistory";
import { filtersToSamplesForm } from "../../../samples/Table/SampleFilterBar";
import { EntityStateIndicator } from "../../badges/EntityStateIndicator/EntityStateIndicator";
import { CustomTypeLabelRenderer } from "../../../Customization/CustomTypes/generics/CustomTypeRenderer";
import { GetPersons } from "../../misc/EntityRenders/EntityRenderer";
import { defaultSamplesFilters } from "../../../samples/Table/SamplesTable";

export const SamplesTile = (props: EntitySidebarTileProps<Sample, SampleFilters>) => {
  const controlsUnfolded = useCallback(
    ({ filters, setFilters }: { filters: SampleFilters; setFilters: Dispatch<SetStateAction<SampleFilters>> }) => {
      return (
        <>
          <RenderTabStoreHistoryButton
            entityConstants={samplesConstants}
            filters={filters}
            filtersToForm={filtersToSamplesForm}
          />
        </>
      );
    },
    []
  );

  return (
    <EntitySidebarTile<Sample, SampleFilters>
      {...props}
      controlsUnfolded={props.controlsUnfolded ?? controlsUnfolded}
      entityConstants={samplesConstants}
      orderByOptions={SampleSortingOptionsConsts}
      translatorConsts={SampleFiltersTranslator}
      defaultFilters={{ ...defaultSamplesFilters, ...props.defaultFilters }}
      rowLabel={(e) => (
        <div className="ellipsisContainer">
          <span>{e.name || NotAvailable}</span>
          <EntityStateIndicator entityConstants={samplesConstants} entity={e} hideLabels />
        </div>
      )}
      rowDate={(e) => (
        <>{e.enteredOn ? <DateTimeRenderer date={e.enteredOn} includeElapsed={false} includeTime={false} /> : NotSet}</>
      )}
      rowInfo={(e) => <>{e.enteredBy ? <GetPersons persons={e.enteredBy} createLinks={false} /> : NotSet}</>}
      rowId={(e) => <CustomTypeLabelRenderer entity={e} />}
    />
  );
};
